import { render, staticRenderFns } from "./FlowViewFlowInfoCard.vue?vue&type=template&id=31634f7b&"
import script from "./FlowViewFlowInfoCard.vue?vue&type=script&lang=ts&"
export * from "./FlowViewFlowInfoCard.vue?vue&type=script&lang=ts&"
import style0 from "./FlowViewFlowInfoCard.vue?vue&type=style&index=0&id=31634f7b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports